import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.useDocumentTitle', {
    documentTitle: '{title} | ApprovalMax',
    defaultDocumentTitle: 'ApprovalMax: cloud approval workflows for finance and accounting',
});
